import React from "react";
import ProductCard from "../components/ProductCard";
import Layout from "../components/Layout";
import styles from "./Sprats.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const spratsProducts = [
  // --- VALMIS ---
  // sprats-valmis-deluxe-tl-240.jpg
  {
    key: "sprats_valmis_deluxe_tl_240",
    image: "/assets/products/canned/sprats/sprats-valmis-deluxe-tl-240.jpg",
  },
  {
    key: "valmis_deluxe_glass_250",
    image: "/assets/products/canned/sprats/sprats-valmis-deluxe-glass-250.jpg",
  },
  {
    key: "valmis_gdansk_170",
    image: "/assets/products/canned/sprats/sprats-valmis-gdansk-key-170.jpg",
  },
  {
    key: "valmis_riga_160",
    image: "/assets/products/canned/sprats/sprats-valmis-riga-key-160.jpg",
  },
  {
    key: "valmis_riga_240",
    image: "/assets/products/canned/sprats/sprats-valmis-riga-key-240.jpg",
  },

  // --- VENTSPILS ---
  {
    key: "ventspils_160",
    image: "/assets/products/canned/sprats/sprats-ventspils-key-160.jpg",
  },
  {
    key: "ventspils_240",
    image: "/assets/products/canned/sprats/sprats-ventspils-key-240.jpg",
  },
  {
    key: "ventspils_tl_240",
    image: "/assets/products/canned/sprats/sprats-ventspils-tl-240.jpg",
  },
  {
    key: "ventspils_190",
    image: "/assets/products/canned/sprats/sprats-ventspils-key-190.jpg",
  },
];

const Sprats = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <h2 className={styles.heading}>{t("sprats.title")}</h2>

      <div className={styles.grid}>
        {spratsProducts.map((product) => (
          <ProductCard
            key={product.key}
            title={t(`sprats.products.${product.key}.title`)}
            weight={t(`sprats.products.${product.key}.weight`)}
            description={t(`sprats.products.${product.key}.description`)}
            image={product.image}
          />
        ))}
      </div>
    </Layout>
  );
};

export default Sprats;
